import { useQuery } from '@tanstack/react-query';
import { getWeeklyLearningGuideNotes } from '../../services/weeklyLearningGuideService';
import { loadWeeklyLearningGuideNotesCache } from '../../utils/weeklyLearningGuideNotesCache';
import { schoolKeys } from '../keys';
import { lsInitialDataOptions } from './lsInitialData';
import type { SchoolGradeTermScope } from './types';

export type UseWeeklyLearningGuideNotesQueryParams = SchoolGradeTermScope & {
  enabled?: boolean;
  forceRefresh?: boolean;
};

export function useWeeklyLearningGuideNotesQuery(params: UseWeeklyLearningGuideNotesQueryParams) {
  const { workspaceId, academicYear, termNumber, gradeId, enabled = true, forceRefresh = false } = params;
  const ls = loadWeeklyLearningGuideNotesCache(workspaceId, academicYear, termNumber, gradeId);

  return useQuery({
    queryKey: schoolKeys.weeklyLearningGuideNotes(workspaceId, academicYear, termNumber, gradeId),
    enabled: enabled && !!workspaceId.trim() && !!gradeId.trim(),
    ...lsInitialDataOptions(!forceRefresh && ls.found, ls.rows),
    queryFn: () => getWeeklyLearningGuideNotes(workspaceId, academicYear, termNumber, gradeId),
  });
}
